import {UpdatePasswordData} from 'attendee/Auth/Interfaces/update_password'
import {useAuth} from 'attendee/Auth/Providers/AuthProvider'
import {ErrorMsg} from 'attendee/Auth/Register'
import {useFormik} from 'formik'
import React, {useMemo, useState} from 'react'
import {toast} from 'react-toastify'
import {getPasswordUpdateSchema} from 'utils/validation-schema'
import {useI18n} from 'i18n/I18nContext'

export default function PasswordUpdate() {
  const {updatePassword} = useAuth()
  const [isBtnDisable, setBtnDisable] = useState(false)
  const {t} = useI18n()
  const passwordSchema = useMemo(() => getPasswordUpdateSchema(t), [t])

  const {handleSubmit, handleBlur, handleChange, values, errors, touched} =
    useFormik({
      initialValues: {
        old_password: '',
        password: '',
        password_confirmation: '',
      },
      validationSchema: passwordSchema,
      onSubmit: async (values: UpdatePasswordData) => {
        setBtnDisable(true)
        const registerResult = await updatePassword(values)

        if (registerResult === true) {
          toast.success(t('form.password.toastChanged'))
        }

        setBtnDisable(false)
      },
    })

  return (
    <form onSubmit={handleSubmit}>
      <div className="singel__input-field mb-15">
        <label className="input__field-text">
          {t('form.password.currentLabel')}
        </label>
        <input
          type="password"
          name={'old_password'}
          value={values.old_password}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.old_password && <ErrorMsg errors={errors.old_password} />}
      </div>
      <div className="singel__input-field mb-15">
        <label className="input__field-text">
          {t('form.password.newLabel')}
        </label>
        <input
          type="password"
          placeholder=""
          name={'password'}
          value={values.password}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.password && <ErrorMsg errors={errors.password} />}
      </div>
      <div className="singel__input-field mb-15">
        <label className="input__field-text">
          {t('form.password.confirmLabel')}
        </label>
        <input
          type="password"
          placeholder=""
          name={'password_confirmation'}
          value={values.password_confirmation}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.password_confirmation && (
          <ErrorMsg errors={errors.password_confirmation} />
        )}
      </div>

      <div className="input__btn-wrapper">
        <button
          className={
            isBtnDisable
              ? 'disableBtnStyle w-100 mb-20'
              : 'input__btn w-100 mb-20'
          }
          type="submit"
          disabled={isBtnDisable}
        >
          {t('form.password.submit')}
        </button>
      </div>
    </form>
  )
}
